import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const LegalContent = dynamic(() =>
  import('modules/legal/LegalContent').then(mod => mod.LegalContent),
);

const TermsAndConditionsPage = () => {
  const { t } = useTranslation('meta');

  const seo = {
    alternate: t('termsAndConditions.alternate', { returnObjects: true }),
    description: t('termsAndConditions.description'),
    image: t('termsAndConditions.image'),
    slug: t('termsAndConditions.slug'),
    title: t('termsAndConditions.title'),
  };
  return (
    <Layout dark seo={seo}>
      <LegalContent
        title={t('pageTermsAndConditions:title')}
        content={t('pageTermsAndConditions:content', { returnObjects: true })}
      />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IContactPageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pageTermsAndConditions',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IContactPageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default TermsAndConditionsPage;
